import { css } from "@emotion/react"

type Props = {
  tag?: "p" | "span"
  children?: React.ReactNode
  theme?: "primary" | "secondary"
  textAlign?: "center"
}

const Text = ({ tag = "p", children, theme = "primary", textAlign }: Props) => {
  const Component = tag
  return (
    <Component css={css(styles.text, theme === "secondary" && styles.secondary)} style={{ textAlign }}>
      {children}
    </Component>
  )
}

export default Text

const styles = {
  text: css`
    line-height: 20px;
    white-space: pre-line;
    &::before {
      /* line-heightで発生する余分な余白を打ち消すための疑似要素です */
      display: block;
      width: 0;
      height: 0;
      margin-top: -3px;
      content: "";
    }
  `,
  secondary: css`
    color: #999999;
  `,
}
